import { useCallback, useEffect, useState } from 'react'
import { useFormGenerationStore } from './FormGenerationContext'
import { ACTIVE_STATUSES, fileProblem, serverMessage } from './formGeneration'

const useFormGeneration = ({ watching = false } = {}) => {
  const store = useFormGenerationStore()
  const [currentId, setCurrentId] = useState(null)
  const [uploading, setUploading] = useState(false)
  const [uploadError, setUploadError] = useState(null)
  const entry = currentId ? store.entries[currentId] : null
  const generation = entry?.generation || null
  const timedOut = !!entry?.timedOut
  const active = !!generation && ACTIVE_STATUSES.includes(generation.status) && !timedOut
  const { watch } = store

  useEffect(() => {
    if (!watching || !currentId) return undefined
    return watch(currentId)
  }, [watching, currentId, watch])

  const start = useCallback(async (file, { buildingPassportId, organisationId, targetType, targetId } = {}) => {
    const problem = fileProblem(file)
    if (problem) {
      setUploadError(problem)
      return false
    }
    setUploadError(null)
    setUploading(true)
    try {
      const id = await store.start({ file, buildingPassportId, organisationId, targetType, targetId })
      setCurrentId(id)
      return true
    } catch (error) {
      setUploadError(serverMessage(error))
      return false
    } finally {
      setUploading(false)
    }
  }, [store])

  const reset = useCallback(() => {
    setCurrentId(null)
    setUploadError(null)
    setUploading(false)
  }, [])

  return { generation, uploading, uploadError, timedOut, active, start, reset }
}

export default useFormGeneration
